import instance from "@/http";
import { httpClient } from "@/services";
import { customerPaymentsHeader } from "@/constants/defaultHeader";
import requestKeys from "@/constants/requestKeys";

export default {
	state: {
		filterPayments: null,
		paymentList: null,
		paymentSettingsDefault: null,
		paymentSettings: null,
		paymentHeaders: [],

		paymentsCustomerList: null,
		paymentsCustomerLimit: null,
		paymentsCustomerOrder: null,
		paymentsCustomerSort: null,
		paymentsCustomerTotal: null,
		paymentsCustomerTotals: null,
		paymentsCustomerFilters: null,
	},
	mutations: {

		updatePaymentsCustomerList(state, { rows, limit, order, sort, total, sum }) {
			const { sum_lost_amount, sum_total_check } = sum;

			state.paymentsCustomerList = rows;
			state.paymentsCustomerLimit = limit;
			state.paymentsCustomerOrder = order;
			state.paymentsCustomerSort = sort;
			state.paymentsCustomerTotal = total;
			state.paymentsCustomerTotals = { id: total, total_check: sum_total_check, amount: sum_lost_amount, };
		},

		updatePaymentsCustomerFilters(state, { filter }) {
			state.paymentsCustomerFilters = filter;
		},

		updateDeletePaymentsCustomer(state, payload) {
			state.paymentsCustomerList = state.paymentsCustomerList.filter(e => e.id !== payload);
		},

	},
	actions: {
		async onSetPayment(context, values) {
			try {
				const { data } = await instance().post("/invoice/setPayments", values);
				if (data) {
					return data;
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getPaymentsCustomer({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/payments-customer/list', filters);

				if (data) {
					commit('updatePaymentsCustomerList', data);
					commit('updateSettings', {
						settings: data.settings,
						key: requestKeys.CUSTOMER_PAYMENTS,
						defaultHeader: customerPaymentsHeader
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getPaymentsCustomerFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/payments-customer/filters', values);
				if (data) commit('updatePaymentsCustomerFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async getDeletePayment({ commit, dispatch }, payload) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await instance().delete(`/payments-customer/${ payload }`);
				commit('updateDeletePaymentsCustomer', payload);
				if (data.status) {
					dispatch("setAlert", { type: "success", message: "✅ The record has been successfully deleted." });
				} else {
					dispatch("setAlert", { type: "error", message: "Remove error" });
				}
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},
	},
	getters: {
		paymentsCustomerList: s => s.paymentsCustomerList,
		paymentsCustomerLimit: s => s.paymentsCustomerLimit,
		paymentsCustomerOrder: s => s.paymentsCustomerOrder,
		paymentsCustomerSort: s => s.paymentsCustomerSort,
		paymentsCustomerTotal: s => s.paymentsCustomerTotal,
		paymentsCustomerTotals: s => s.paymentsCustomerTotals,
		paymentsCustomerFilters: s => s.paymentsCustomerFilters,

		paymentList: s => s.paymentList,
		filterPayments: s => s.filterPayments,
		paymentSettingsDefault: s => s.paymentSettingsDefault,
		paymentSettings: s => s.paymentSettings
	},
};
